
export default {
  setup() {},
  props: {
    displayModal: {
      type: Boolean,
      default: false,
    },
    modal1: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      if (this.displayModal) {
        this.$emit("update:displayModal", false);
      } else {
        this.$emit("update:modal1", false);
      }
    },
  },
};
